import {
  createSlice,
  //createEntityAdapter
} from '@reduxjs/toolkit';

export interface InitialState {}

/*
//Note example for create entity
https://redux-toolkit.js.org/usage/usage-with-typescript#createentityadapter

const productsAdapter = createEntityAdapter<Product>();

const initialState: InitialState = productsAdapter.getInitialState();
*/

const initialState: InitialState = {};

export const modalMockSlice = createSlice({
  name: 'modalMock-page',
  initialState,
  reducers: {},
  extraReducers(builder) {
    /*
    Note example for extra reducers
    https://redux-toolkit.js.org/usage/usage-with-typescript#createasyncthunk

    builder.addCase(action.fulfilled, (state, { payload }) => {
      state.entities[payload.id] = payload
    })
    */
  },
});

// export const {} = modalMockSlice.actions;

export default modalMockSlice.reducer;
